function looklabProgressBar() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            document.querySelectorAll('.combo-progress-container').forEach(container => {
                // Get product IDs from the hidden div
                const productIdsText = document.querySelector('.looklab-product-ids').textContent.trim();
                const productIds = productIdsText.split(',').map(id => parseInt(id, 10));
                const freeItemVariantId = parseInt(container.dataset.freeItemId, 10);
                let totalQty = 0;

                // Sum up the quantity of matching products in the cart
                cart.items.forEach(item => {
                    if (productIds.includes(item.product_id)) {
                        totalQty += item.quantity;
                    }
                });
                
                console.log(`Combo Progress - Items: ${productIds} | Total Qty: ${totalQty}`);
              
                const progressContainer = document.querySelector('.combo-progress-container.combo-progress-cart-template');
                if (progressContainer) {  // Check if element exists
                    if (totalQty >= 1) {
                        progressContainer.classList.remove('hideit');
                    } else {
                        progressContainer.classList.add('hideit');
                    }
                }
                // --- UI Updates ---
                const milestones = container.querySelectorAll('.combo-milestone');
                const progressBar = container.querySelector('.combo-progress-bar');
                const message = container.querySelector('.combo-progress-message');
                
                // Calculate total amount and savings
                const priceElement = document.querySelector('.price-item.price-item--regular');
                let savedAmount = 0;
                let savingsMessage = "";
                
                if (priceElement) {
                    // Calculate from product price if element exists
                    const totalAmount = parseFloat(priceElement.textContent.replace('£', '').replace(',', '').trim());
                    
                    if (totalQty === 2 || totalQty === 3) {
                        savedAmount = totalAmount * 0.2; // 20% discount
                    } else if (totalQty >= 4) {
                        savedAmount = totalAmount * 0.4; // 40% discount
                    }
                    savingsMessage = `and saved £${savedAmount.toFixed(2)}`;
                } else {
                    // Calculate from cart item discounts if price element not found
                    const discountItems = cart.items.filter(item => productIds.includes(item.product_id));
                    const savedCartAmount = discountItems.reduce((total, item) => {
                        return total + (item.total_discount || 0);
                    }, 0) / 100;
                    
                    if (savedCartAmount > 0) {
                        savingsMessage = `and saved £${savedCartAmount.toFixed(2)}`;
                    }
                }

                // Check if the current look products are in cart or not
                // const currentLookProductIdsText = $('.combo-progress-container').data('items');
                // const currentLookProductIds = currentLookProductIdsText.split(',').map(id => parseInt(id, 10));
                // const currentLookItemsInCart = cart.items.filter(item => currentLookProductIds.includes(item.product_id));

                // Check if any scarf is in cart or not
                const scarfsProductIdsText = $('.looklab-scarf-product-ids').html();
                const scarfsProductIds = scarfsProductIdsText.split(',').map(id => parseInt(id, 10));
                const scarfsInCart = cart.items.filter(item => scarfsProductIds.includes(item.product_id) && item.final_price == 0);
                
                // Set messages based on quantity
                let unlockedMessage = "";
                let lockedMessage = "";

                let freeScarfMessage = '';
                if(scarfsInCart.length > 0){
                    freeScarfMessage = '+ free scarf';
                }
                
                if (totalQty === 0) {
                    lockedMessage = "Add 2 item(s) to get 20% off";
                } else if (totalQty === 1) {
                    lockedMessage = "Add another item to get 20% off";
                } else if (totalQty === 2) {
                    unlockedMessage = `Congratulations! You got 20% off! ${savingsMessage}`.trim();
                    lockedMessage = "Add another item to get a scarf free";
                } else if (totalQty === 3) {
                    unlockedMessage = `Congratulations! You got 20% off ${freeScarfMessage} ${savingsMessage}`.trim();
                    lockedMessage = "Add another item to get 40% off";
                } else if (totalQty >= 4) {
                    unlockedMessage = `Congratulations! You got 40% off ${freeScarfMessage} ${savingsMessage}`.trim();
                    lockedMessage = "Great! You've applied all discounts";
                }

                

                // Update progress message
                  if (message) {
                    // Clear previous messages
                    const unlockedElements = message.querySelectorAll('.unlocked');
                    const lockedElements = message.querySelectorAll('.locked');
                    
                    unlockedElements.forEach(el => el.textContent = '');
                    lockedElements.forEach(el => el.textContent = '');
                    
                    // Update first available unlocked element
                    if (unlockedMessage && unlockedElements.length > 0 ) {
                        unlockedElements[0].textContent = unlockedMessage;
                    }
                    
                    // if(totalQty != 0 && currentLookItemsInCart.length == 0){
                    //   $(unlockedElements[0]).html(unlockedMessage+`<br/>Keep going and Explore this look for more rewards.`);
                    // }

                    if(totalQty >= 3 && scarfsInCart.length == 0){
                      $('.add-scarf-message').html(`<strong style="color: #FF0000;">Claim your FREE Scarf:</strong> Just add your favorite to the cart from this look or browse 
                      <a style="text-decoration: underline;" class="view-multiwear-products view-all-scarf" data-original-text="View All Scarfs" data-label-text="Scarfs" 
                      data-tag="looklab_scarfs" data-title="Explore The Scarfs Collection" data-product-id="">All Scarfs</a>!`);

                      $('.add-scarf-message-popup').html(`<strong style="color: #FF0000;">Claim your FREE Scarf:</strong> Just add your favorite to the cart from this look or from here:`);
                      
                    }else{
                      $('.add-scarf-message').html('');
                      $('.add-scarf-message-popup').html('');
                    }
                    
                    // Update first available locked element if conditions met
                    if (lockedMessage && lockedElements.length > 0 && (!unlockedMessage || totalQty >= 2)) {
                        lockedElements[0].textContent = lockedMessage;
                    }
                }

                // Update progress bar width
                if (progressBar) {
                    let progressPercent = 0;
                    if (totalQty >= 4) progressPercent = 100;
                    else if (totalQty >= 3) progressPercent = 75;
                    else if (totalQty >= 2) progressPercent = 25;
                    else if (totalQty >= 1) progressPercent = 10;
                    
                    progressBar.style.width = `${progressPercent}%`;
                }

                // Update milestone visuals
                if (milestones) {
                    milestones.forEach((milestone, index) => {
                        const requiredQty = parseInt(milestone.dataset.qty, 10);
                        milestone.classList.toggle('active', totalQty >= requiredQty);
                    });
                }


                // Function to update all combo prices
                  function updateComboPrices(totalQty) {
                      document.querySelectorAll('.combo-price-wrapper').forEach(wrapper => {
                          const priceElement = wrapper.querySelector('.combo-price');
                          const discountedElement = wrapper.querySelector('.combo-discounted-price');
                          
                          if (priceElement && discountedElement) {
                              const originalPrice = parseFloat(priceElement.textContent.replace('£', '').trim());
                              let discountedPrice = originalPrice;
                              let discountText = '';
                              
                              // Apply discounts based on quantity
                              if (totalQty === 2 || totalQty === 3) {
                                  discountedPrice = originalPrice * 0.8; // 20% off
                                  discountText = ``; //20% OFF
                              } else if (totalQty >= 4) {
                                  discountedPrice = originalPrice * 0.6; // 40% off
                                  discountText = ``; //40% OFF
                              }
                              
                              // Update the display
                              if (totalQty >= 2) {
                                  priceElement.style.textDecoration = 'line-through';
                                  discountedElement.innerHTML = `
                                      <span class="new-price" style="color:red">£${discountedPrice.toFixed(2)}</span>
                                      <span class="discount-badge">${discountText}</span>
                                  `;
                              } else {
                                  discountedElement.textContent = ''; // Clear if no discount applies
                              }
                          }
                      });
                  }
                  
                  // Call this function whenever totalQty changes
                //  updateComboPrices(totalQty);
              
                // Handle free item
                const freeItem = cart.items.find(item => item.variant_id === freeItemVariantId);
                if (totalQty >= 3) {
                    if (!freeItem) {
                        console.log('Adding Free Item to cart...');
                        // addFreeItemToCart(freeItemVariantId);
                    }
                } else {
                    if (freeItem) {
                        console.log('Removing Free Item from cart...');
                        // removeFreeItemFromCart(freeItem.key);
                    }
                }
            });
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
        });
}

// Rest of the functions remain the same
function addFreeItemToCart(variantId) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(response => response.json())
    .then(data => {
        console.log('Free Item added:', data);
        looklabProgressBar(); // Refresh progress after adding
    })
    .catch(error => console.error('Error adding free item:', error));
}

function removeFreeItemFromCart(itemKey) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity: 0 })
    })
    .then(response => response.json())
    .then(data => {
        console.log('Free Item removed:', data);
        looklabProgressBar(); // Refresh progress after removing
    })
    .catch(error => console.error('Error removing Free Item:', error));
}

looklabProgressBar();

window.scarfCheckIntervals = window.scarfCheckIntervals || {};
window.hasScarfLinkBeenClickedMap = window.hasScarfLinkBeenClickedMap || {};

window.triggerScarfLinkClick = function (selector, force = false) {
    console.log(`triggerScarfLinkClick for ${selector}, force: ${force}`);
    if (force) {
        window.hasScarfLinkBeenClickedMap[selector] = false;
    }

    if (window.scarfCheckIntervals[selector]) {
        clearInterval(window.scarfCheckIntervals[selector]);
        delete window.scarfCheckIntervals[selector]; 
    }

    if (window.hasScarfLinkBeenClickedMap[selector]) return;

    window.scarfCheckIntervals[selector] = setInterval(() => {
        const scarfLink = document.querySelector(selector);
        if (scarfLink) {
            console.log(`Clicking: ${selector}`);
            scarfLink.click();
            window.hasScarfLinkBeenClickedMap[selector] = true;
            clearInterval(window.scarfCheckIntervals[selector]);
            delete window.scarfCheckIntervals[selector];
        }
    }, 300);
};
window.triggerScarfLinkClick('.add-scarf-message .view-multiwear-products.view-all-scarf');
//window.triggerScarfLinkClick('#add-scarf-cart .view-multiwear-products.view-all-scarf-cart-drawer');

document.addEventListener('DOMContentLoaded', function() {
  
  const bundleImages = document.querySelectorAll('.bundle_image');
  
  bundleImages.forEach(function(image) {
    
    image.addEventListener('click', function(e) {
      e.preventDefault();
      
      const link = document.createElement('a');
      link.href = this.src;
      link.setAttribute('data-fancybox', 'bundle-gallery');
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
    });
  });
});